export const stackStyles = {
  root: {
    border: "2px solid #000", // Set the border style and color
    padding: 20, // Adjust padding as needed
  },
};
